<template>
  <div class="navMenu">
    <div v-for="(navMenu,i) of navMenus" :key="i">
      <el-menu-item v-if="navMenu.children==undefined" :index="navMenu.path">
        <i :class="'el-icon-'+navMenu.meta.icon"></i>
        <span slot="title">{{navMenu.meta.title}}</span>
      </el-menu-item>
      <el-submenu v-if="navMenu.children" :index="navMenu.path">
        <template slot="title">
          <i :class="'el-icon-'+navMenu.meta.icon"></i>
          <span>{{navMenu.meta.title}}</span>
        </template>
        <NavMenu :navMenus="navMenu.children"></NavMenu>
      </el-submenu>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "NavMenu",
  created() {
  },
  props: ["navMenus"],
  data() {
    return {
      // navMenus:[
      // ]
    };
  },
  methods: {}
};
</script>
  
<style scoped>
</style>